export const ToastActionType = {
  Show: "show",
  Dismiss: "dismiss",
  Destroy: "destroy"
};

export const ToastType = {
  DefaultUC: "DefaultUC",
  RegulationLogin: "RegulationLogin"
};

export const LimitPeriodTypes = {
  Daily: 1,
  Weekly: 2,
  Monthly: 5
};
